// BooksView.jsx — THE RECORD FILE (Braeden 8/13)
//
//   "make the ENTIRE books thing, just a big record list ... litterally put
//    everything in there in sections, like the system one just this one is the
//    record file, Job Files, Envoices, pictures, etc, taxe info, customer info,
//    etc add littereally everything"
//
// So: the Systems page's shape — grouped sections of rows — except every
// section is a drawer of the filing cabinet instead of an automation. Job
// files, quotes, invoices, payments, expenses, payroll, customer files, leads,
// reviews, follow-ups, what Aria did, and the drawers that are named but not
// yet wired (photos, taxes, licenses, equipment, vendors, contracts, texts).
//
// The sections come from GET /api/bizops/records, derived server-side from the
// live stores. Nothing is invented here: a drawer with no store behind it says
// exactly what it needs instead of showing rows that would be a lie.
import React from 'react';
import { getApiBase } from './apiBase';

const STYLE = `
.rec { --rc-ink:#eaf0f8; --rc-mut:rgba(255,255,255,0.55); --rc-dim:rgba(255,255,255,0.38);
  --rc-card:rgba(255,255,255,0.045); --rc-line:rgba(255,255,255,0.10); --rc-acc:#0a84ff;
  --rc-in:#4d8dff; --rc-out:#ff8a5b; --rc-pill:rgba(255,255,255,0.07);
  --rc-gap:rgba(255,255,255,0.02); --rc-onink:#0b1020;
  padding:26px 20px 72px; }
/* DAY THEME — every colour redefined, never inherited. */
.rec.is-light { --rc-ink:#0e1420; --rc-mut:rgba(0,0,0,0.58); --rc-dim:rgba(0,0,0,0.40);
  --rc-card:#fff; --rc-line:rgba(0,0,0,0.12); --rc-acc:#0a6bd4;
  --rc-in:#0a6bd4; --rc-out:#c2410c; --rc-pill:rgba(0,0,0,0.06);
  --rc-gap:rgba(14,20,32,0.03); --rc-onink:#fff; }
.rec__wrap { max-width:900px; margin:0 auto; }
.rec__title { font-size:34px; font-weight:800; letter-spacing:-0.8px; color:var(--rc-ink); margin:0 0 4px; }
.rec__sub { font-size:13px; font-weight:700; letter-spacing:0.1em; text-transform:uppercase; color:var(--rc-acc); margin-bottom:10px; }
.rec__lead { font-size:15px; color:var(--rc-mut); margin:0 0 20px; max-width:62ch; }

.rec__search { width:100%; background:var(--rc-card); border:1px solid var(--rc-line); border-radius:999px;
  padding:11px 18px; font-size:14px; font-weight:600; color:var(--rc-ink); font-family:inherit; outline:none;
  box-sizing:border-box; margin-bottom:12px; }
.rec__search:focus { border-color:var(--rc-acc); }
.rec__search::placeholder { color:var(--rc-dim); font-weight:500; }

/* jump bar — 18 drawers is too many to scroll blind */
.rec__jump { display:flex; flex-wrap:wrap; gap:7px; margin-bottom:8px; }
.rec__chip { background:var(--rc-card); border:1px solid var(--rc-line); color:var(--rc-mut);
  border-radius:999px; padding:6px 13px; font-size:12px; font-weight:700; cursor:pointer; }
.rec__chip:hover { color:var(--rc-ink); border-color:var(--rc-acc); }
.rec__chip b { color:var(--rc-ink); font-weight:800; }
.rec__chip--empty { opacity:.55; }
.rec__showing { font-size:12px; font-weight:600; color:var(--rc-dim); margin:10px 2px 2px; }

.rec__group { margin-top:26px; scroll-margin-top:14px; }
.rec__ghead { display:flex; align-items:baseline; justify-content:space-between; gap:12px;
  margin:0 2px 10px; padding-bottom:8px; border-bottom:1px solid var(--rc-line); }
.rec__gname { font-size:12px; font-weight:800; letter-spacing:0.14em; text-transform:uppercase; color:var(--rc-acc); }
.rec__gnote { font-size:12px; font-weight:500; color:var(--rc-dim); text-transform:none; letter-spacing:0; }
.rec__gcount { font-size:11px; font-weight:700; color:var(--rc-mut); white-space:nowrap; }

.rec__row { display:grid; grid-template-columns:minmax(150px,0.9fr) 1.5fr auto; align-items:baseline;
  gap:14px; padding:14px 18px; margin-bottom:8px; border-radius:14px;
  background:var(--rc-card); border:1px solid var(--rc-line); }
.rec__name { font-size:15px; font-weight:700; letter-spacing:-0.2px; color:var(--rc-ink); line-height:1.3; min-width:0; }
.rec__who { color:var(--rc-mut); font-weight:600; }
.rec__mid { min-width:0; }
.rec__detail { font-size:13px; color:var(--rc-mut); line-height:1.4; }
.rec__meta { display:flex; flex-wrap:wrap; gap:6px; margin-top:6px; }
.rec__tag { font-size:10px; font-weight:800; letter-spacing:0.06em; text-transform:uppercase;
  padding:3px 9px; border-radius:999px; background:var(--rc-pill); color:var(--rc-mut); }
.rec__right { justify-self:end; text-align:right; white-space:nowrap; }
.rec__amt { font-size:16px; font-weight:800; letter-spacing:-0.02em; color:var(--rc-in); font-variant-numeric:tabular-nums; }
.rec__amt--out { color:var(--rc-out); }
.rec__when { display:block; font-size:11px; font-weight:700; color:var(--rc-dim); margin-top:3px; }

.rec__more { width:100%; background:transparent; border:1px dashed var(--rc-line); color:var(--rc-mut);
  border-radius:12px; padding:10px; font-size:12px; font-weight:700; cursor:pointer; font-family:inherit; }
.rec__more:hover { color:var(--rc-acc); border-color:var(--rc-acc); }
.rec__none { font-size:13px; color:var(--rc-dim); padding:13px 18px; border-radius:14px;
  background:var(--rc-gap); border:1px dashed var(--rc-line); }
/* a drawer that has no store behind it — never dressed up as working */
.rec__gapbox { padding:14px 18px; border-radius:14px; background:var(--rc-gap); border:1px dashed var(--rc-line); }
.rec__gaplab { font-size:10px; font-weight:800; letter-spacing:0.08em; text-transform:uppercase; color:var(--rc-out); }
.rec__gaptext { font-size:13px; color:var(--rc-mut); line-height:1.5; margin-top:5px; }
.rec__empty { color:var(--rc-mut); font-size:15px; line-height:1.6; padding:34px 2px; }
.rec__empty b { display:block; color:var(--rc-ink); font-size:17px; font-weight:800; margin-bottom:5px; }
@media (max-width:760px) {
  .rec { padding:20px 14px 60px; }
  .rec__title { font-size:27px; }
  .rec__row { grid-template-columns:1fr auto; gap:5px 12px; padding:14px 16px; }
  .rec__mid { grid-column:1 / -1; }
  .rec__right { grid-column:2; grid-row:1; }
}
`;

// THE DRAWERS ALWAYS EXIST (Braeden 8/13: "there should already be a list even
// if there is nothing in them, should still be a list of everything"). The
// server fills them; this is the cabinet itself, so the full list renders even
// if the fetch 403s, times out, or the business is brand new with no records.
// Keys and titles mirror services/bizOps/books.js sections().
const DRAWERS = [
  ['jobs', 'Job files', 'Every job booked, worked, or cancelled'],
  ['quotes', 'Quotes & estimates', 'What was priced, and whether it turned into work'],
  ['invoices', 'Invoices', 'Every bill raised — draft, sent, paid'],
  ['payments', 'Payments received', 'Money that actually landed'],
  ['expenses', 'Expenses & receipts', 'Every dollar out, categorised for taxes'],
  ['payroll', 'Payroll', 'Who was paid, for what, and when'],
  ['customers', 'Customer files', 'Everyone worked for — contact, history, what they spent'],
  ['leads', 'Leads', 'Everyone who reached out, and where they came from'],
  ['reviews', 'Review requests', 'Who was asked, who left one'],
  ['followups', 'Follow-ups', 'Quiet quotes and unpaid invoices being chased'],
  ['aria', 'What Aria did', 'Every action taken on the business’s behalf'],
  ['photos', 'Job photos', 'Before & after on every job — the proof', 'No photo store yet.'],
  ['taxes', 'Tax records', 'Quarterly set-aside, filings, 1099s and W-2s', 'Nothing files or sets aside tax yet.'],
  ['licenses', 'Licenses, insurance & filings', 'What has to stay current, and when it expires', 'No renewals store yet.'],
  ['equipment', 'Truck & equipment', 'Service history by mileage or hours', 'No equipment store yet.'],
  ['vendors', 'Suppliers & subcontractors', 'W-9s and insurance certs before anyone works', 'No vendor store yet.'],
  ['contracts', 'Signed documents', 'Contracts, change orders, anything with a signature on it', 'The e-sign tool does not write here yet.'],
  ['messages', 'Texts & calls', 'Every conversation with a customer', 'Must be read from the Twilio Messages API, not a local log.'],
];

const COLLAPSE_AT = 10;   // rows shown before a section offers "show all"
const money = (n) => '$' + Math.abs(Number(n || 0)).toLocaleString(undefined, { maximumFractionDigits: 2 });
const when = (s) => { try { return new Date(s).toLocaleDateString('en-US', { month: 'short', day: 'numeric' }); } catch (_) { return ''; } };

export default function BooksView({ theme, onNavigate }) {
  // bizops writes under `howto_owner_id || 'owner-default'` — see JobsPage.
  // Any other key reads an empty file with a full one sitting there (8/13).
  const bookOwner = React.useMemo(() => {
    try { return localStorage.getItem('howto_owner_id') || 'owner-default'; }
    catch (_) { return 'owner-default'; }
  }, []);

  // Start from the full cabinet, not an empty array — so the list of every
  // drawer is on screen from the first paint, before the fetch even lands.
  const [served, setServed] = React.useState(null);
  const [sum, setSum] = React.useState(null);
  const sections = React.useMemo(() => {
    const byKey = new Map((served || []).map((s) => [s.key, s]));
    // Server data wins. The fallback keeps the same wired/gap distinction, so
    // a failed fetch still cannot make an unbuilt drawer look merely empty.
    return DRAWERS.map(([key, title, note, needs]) => byKey.get(key)
      || { key, title, note, wired: !needs, needs, rows: [], count: 0, more: 0 });
  }, [served]);
  const [q, setQ] = React.useState('');
  const [openAll, setOpenAll] = React.useState({});
  const [loading, setLoading] = React.useState(true);

  React.useEffect(() => {
    let dead = false;
    let tok = '';
    try { tok = localStorage.getItem('aria_session_token') || ''; } catch (_) {}
    fetch(`${getApiBase()}/api/bizops/records?ownerId=${encodeURIComponent(bookOwner)}`,
      tok ? { headers: { Authorization: `Bearer ${tok}` } } : undefined)
      .then((r) => r.json())
      .then((d) => { if (dead) return; setServed(d.sections || []); setSum(d.summary || null); setLoading(false); })
      .catch(() => { if (!dead) setLoading(false); });
    return () => { dead = true; };
  }, [bookOwner]);

  // one search across every drawer at once — the question this page answers
  // most is "where is that thing", and the owner does not know which drawer.
  const shown = React.useMemo(() => {
    const needle = q.trim().toLowerCase();
    if (!needle) return sections;
    return sections
      .map((s) => ({
        ...s,
        rows: s.rows.filter((r) => [r.title, r.who, r.detail, r.ref, r.status, ...(r.meta || [])]
          .filter(Boolean).join(' ').toLowerCase().includes(needle)),
      }))
      .map((s) => ({ ...s, count: s.rows.length, more: 0 }))
      .filter((s) => s.rows.length > 0);
  }, [sections, q]);

  const hits = shown.reduce((n, s) => n + s.rows.length, 0);

  return (
    <div className={`rec${theme === 'day' ? ' is-light' : ''}`}>
      <style>{STYLE}</style>
      <div className="rec__wrap">
        <h1 className="rec__title">Books</h1>
        <div className="rec__sub">
          {sum ? `${sum.records} records · ${sum.filled} of ${sum.wiredSections} drawers filled · ${sum.gaps} not wired yet`
               : loading ? `${DRAWERS.length} drawers · reading…`
               : `${DRAWERS.length} drawers · nothing filed yet`}
        </div>
        <p className="rec__lead">
          The whole record file, drawer by drawer. Everything the business has done and everything Aria did for it. What runs the business is under Systems.
        </p>

        <input className="rec__search" value={q} onChange={(e) => setQ(e.target.value)}
               placeholder="Search every drawer — a name, an invoice number, an address, anything" />

        {!q && sections.length > 0 && (
          <div className="rec__jump">
            {sections.map((s) => (
              <button key={s.key} type="button"
                      className={'rec__chip' + (s.count ? '' : ' rec__chip--empty')}
                      onClick={() => { const el = document.getElementById('rec-' + s.key); if (el) el.scrollIntoView({ behavior: 'smooth', block: 'start' }); }}>
                {s.title} {s.count ? <b>{s.count}</b> : null}
              </button>
            ))}
          </div>
        )}

        {q && <div className="rec__showing">{hits} record{hits === 1 ? '' : 's'} across {shown.length} drawer{shown.length === 1 ? '' : 's'}</div>}

        {/* No "the file is empty" screen. Every drawer is always on the page —
            an empty drawer is a fact about the business, not a reason to hide
            the cabinet (8/13). Only a search with no hits replaces the list. */}
        {q && shown.length === 0 ? (
            <div className="rec__empty"><b>Nothing matches “{q}”.</b>Try a customer name, an invoice number, or an address.</div>
          ) : shown.map((s) => {
            const all = openAll[s.key] || !!q;
            const rows = all ? s.rows : s.rows.slice(0, COLLAPSE_AT);
            const hidden = s.rows.length - rows.length;
            return (
              <div className="rec__group" id={'rec-' + s.key} key={s.key}>
                <div className="rec__ghead">
                  <span className="rec__gname">{s.title} <span className="rec__gnote">{s.note}</span></span>
                  <span className="rec__gcount">
                    {s.wired ? `${s.count} record${s.count === 1 ? '' : 's'}${s.more ? ` (${s.more} older)` : ''}` : 'not wired yet'}
                  </span>
                </div>

                {!s.wired ? (
                  <div className="rec__gapbox">
                    <span className="rec__gaplab">Nothing files here yet</span>
                    <div className="rec__gaptext">{s.needs}</div>
                  </div>
                ) : s.rows.length === 0 ? (
                  <div className="rec__none">{loading ? 'Reading…' : 'Empty — nothing filed in this drawer yet.'}</div>
                ) : (
                  <>
                    {rows.map((r, i) => (
                      <div className="rec__row" key={(r.ref || '') + (r.at || '') + i}>
                        <span className="rec__name">
                          {r.title}{r.who ? <span className="rec__who"> — {r.who}</span> : null}
                        </span>
                        <span className="rec__mid">
                          {r.detail ? <div className="rec__detail">{r.detail}</div> : null}
                          {((r.meta && r.meta.length) || r.status || r.ref) ? (
                            <div className="rec__meta">
                              {r.status ? <span className="rec__tag">{r.status}</span> : null}
                              {(r.meta || []).map((m, k) => <span className="rec__tag" key={k}>{m}</span>)}
                              {r.ref ? <span className="rec__tag">{r.ref}</span> : null}
                            </div>
                          ) : null}
                        </span>
                        <span className="rec__right">
                          {r.amount != null && (
                            <span className={'rec__amt' + (r.amount < 0 ? ' rec__amt--out' : '')}>
                              {r.amount < 0 ? '−' : ''}{money(r.amount)}
                            </span>
                          )}
                          {r.at ? <span className="rec__when">{when(r.at)}</span> : null}
                        </span>
                      </div>
                    ))}
                    {hidden > 0 && (
                      <button type="button" className="rec__more"
                              onClick={() => setOpenAll((o) => ({ ...o, [s.key]: true }))}>
                        Show all {s.rows.length} — {hidden} more
                      </button>
                    )}
                  </>
                )}
              </div>
            );
          })}
      </div>
    </div>
  );
}
